import { CalendarOutlined } from "@ant-design/icons";
import { Button, DatePicker, Modal } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";

const { RangePicker } = DatePicker;

interface IProps {
  handleClose: () => void;
  open: boolean;
  handleSetDate: (value: [Dayjs, Dayjs]) => void;
}

const startDate = new Date();
startDate.setDate(startDate.getDate() - 30); // Default to 30 days ago
const endDate = new Date();

export default function DateRangeModal({
  handleClose,
  open,
  handleSetDate,
}: IProps) {
  const [date, setDate] = useState<[Dayjs | null, Dayjs | null]>([
    dayjs(startDate),
    dayjs(endDate),
  ]);
  const handleConfirm = () => {
    if (date[0] && date[1]) {
      handleSetDate([date[0], date[1]]);
      handleClose();
    }
  };
  const handleDateRangeChange = (_: any, dateStrings: [string, string]) => {
    if (dateStrings[0] === "" || dateStrings[1] === "") setDate([null, null]);
    else setDate([dayjs(dateStrings[0]), dayjs(dateStrings[1])]);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      title={<div className="text-start text-xl">Select Date Range</div>}
    >
      <div className="flex flex-col gap-4 pt-10 px-3">
        <div className="w-full flex justify-center items-center text-gray-600 mb-5">
          <CalendarOutlined className="text-8xl" />
        </div>
        <div className="w-full text-center">
          <p className="text-gray-500 text-lg">Select a date range</p>
          {date[0] && date[1] ? (
            <p className="text-gray-500 text-base mt-3 mb-2">
              From
              <span className="font-semibold pl-1">
                {date[0].format("ddd, MMM D, YYYY")}
              </span>{" "}
              to
              <span className="font-semibold pl-1">
                {date[1].format("ddd, MMM D, YYYY")}
              </span>
            </p>
          ) : (
            <p className="text-gray-500 text-base mt-3 mb-2"> Not selected</p>
          )}
        </div>
        <RangePicker
          size="large"
          onChange={handleDateRangeChange}
          value={date[0] && date[1] ? date : undefined}
        />

        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleConfirm} type="primary">
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
}
